import { FC } from 'react';
import CommonPage from '../components/page/CommonPage';
import MdmUserList from '../components/mdmuser/MdmUserList';
import { PageTitle } from '../components/common/PageTitle';

const MdmUserListPage : FC= () => {

    return (
        <CommonPage selectBtnIndex={3}>
            <PageTitle title="アカウント一覧" />
            <MdmUserList />
        </CommonPage>
    )
}

export default MdmUserListPage;